/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Tournament_1_HeadingInputs */

const en_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oculomotor tracking and rotation`)
};

const es_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento oculomotor y rotación`)
};

const de_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulomotorische Verfolgung und Rotation`)
};

const zh_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`眼球追踪与转动`)
};

const ar_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التتبع الحركي البصري والدوران`)
};

const fr_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi et rotation oculomoteurs`)
};

const vi_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi vận nhãn và xoay`)
};

const sw_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ufuatiliaji wa macho na mzunguko`)
};

const th_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การติดตามด้วยสายตาและการหมุน`)
};

const bs_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulomotorni tracking i rotacija`)
};

const ja_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`眼球運動による追跡と回旋`)
};

const ko_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안구 운동 추적과 회전`)
};

const pt_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamento ocular e rotação`)
};

const it_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inseguimento oculomotorio e rotazione`)
};

const sv_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulomotorisk följning och rotation`)
};

const nl_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oogbewegingen en rotatie`)
};

const da_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øjenbevægelser og rotation`)
};

const nb_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulomotorisk følging og rotasjon`)
};

const fi_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silmänliikkeiden seuranta ja rotaatio`)
};

const pl_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzenie wzrokiem a rotacja`)
};

const ru_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слежение глазами и вращение`)
};

const tr_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okülomotor takip ve rotasyon`)
};

const hi_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आँखों से पीछा करना और घुमाव`)
};

const id_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacakan okulomotor dan rotasi`)
};

const ms_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjejakan okulomotor dan putaran`)
};

const cs_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulomotorické sledování a rotace`)
};

const el_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οφθαλμοκινητική παρακολούθηση και περιστροφή`)
};

const he_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעקב עיניים וסיבוב`)
};

const af_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okulomotoriese volging en rotasie`)
};

const hu_method_content_step_04_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szemmozgásos követés és forgás`)
};

/**
* | output |
* | --- |
* | "Oculomotor tracking and rotation" |
*
* @param {Method_Content_Step_04_Detail_Tournament_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_tournament_1_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Tournament_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Tournament_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_tournament_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_tournament_1_heading(inputs)
	return en_method_content_step_04_detail_tournament_1_heading(inputs)
});